import styles from './datepicker-size.module.css'

export function getDatePickerSizeClass(intl, dateRange) {
    return styles[getDatePickerSize(intl, dateRange)]
}

export function getDatePickerSize(intl, dateRange) {
    const showTime =
        !!dateRange &&
        ((dateRange.start && dateRange.start.getHours() !== 0) ||
            (dateRange.start && dateRange.start.getMinutes() !== 0) ||
            (dateRange.end && dateRange.end.getHours() !== 23) ||
            (dateRange.end && dateRange.end.getMinutes() !== 59))
    if (!showTime) {
        return 'small'
    }
    const REGEX_12_HOUR = /[\s\S]*(AM|PM)/
    const formattedTime = intl.formatTimeOnly(dateRange.start)
    return formattedTime && formattedTime.match(REGEX_12_HOUR) ? 'long' : 'medium'
}
